import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Layout } from '../components/Layout';
import { useAuth } from '../contexts/AuthContext';
import { API_URL } from '../components/comercial360/com360Shared';
import { ComercialHeader } from '../components/comercial360/ComercialHeader';
import { TodoPanel } from '../components/comercial360/TodoPanel';
import { MonthContracts } from '../components/comercial360/MonthContracts';
import { ClientsPanel } from '../components/comercial360/ClientsPanel';

export default function Comercial360Page() {
  const { id } = useParams();
  const { user } = useAuth();
  const [month, setMonth] = useState(null);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  const load = useCallback(() => {
    setError('');
    axios.get(`${API_URL}/comerciais/${id}/360`, { params: { month: month || undefined } })
      .then((r) => { setData(r.data); if (!month) setMonth(r.data.meta.mes); })
      .catch((e) => setError((typeof e.response?.data?.detail === 'string' && e.response.data.detail) || 'Erro ao carregar o comercial'));
  }, [id, month]);
  useEffect(() => { load(); }, [load]);

  let body;
  if (error) body = <div className="p-4 rounded-xl bg-rose-50 text-rose-800 text-sm" data-testid="com360-error">{error}</div>;
  else if (!data) body = <div className="flex justify-center py-20"><div className="spinner" /></div>;
  else body = (
    <div className="space-y-5" data-testid="com360-page">
      <ComercialHeader c={data.comercial} meta={data.meta} month={month || data.meta.mes} setMonth={setMonth}
        canEdit={['super_admin', 'gestor'].includes(user?.role)} onSaved={load} />
      <TodoPanel pf={data.por_fazer} />
      <MonthContracts data={data.contratos_mes} month={data.meta.mes} hist={data.historico} meta={data.comercial.meta_mensal} />
      <ClientsPanel clientes={data.clientes} total={data.clientes_total} leads={data.por_fazer.leads} />
    </div>
  );
  return <Layout>{body}</Layout>;
}
